import { render, staticRenderFns } from "./mobile-close.vue?vue&type=template&id=2b40b7d3&"
import script from "./mobile-close.vue?vue&type=script&lang=js&"
export * from "./mobile-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports